import type { FaireProductEntity } from "../../entity_types/product";

export const p_qq65km9w97: FaireProductEntity = {
  token: "p_qq65km9w97",
  type: "product",
  name: "Cream City Baseball Ice Cream HyperMAX Short Sleeve Hoodie",
  brandToken: "b_3kr7fe4stt",
  brandName: "Seamhead Swag",
  imageUrl:
    "https://cdn.faire.com/fastly/ef3ddac904ba66627c6b1484babd26e64bc5a3ee52c0afb93df382d5eb57e474.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c47563c80bef8f81a04ff8299aad15874c2be92b621f50a9216d4cd79e0d18ab.png",
    "https://cdn.faire.com/fastly/63b016d5d090849aac05323b7151a60d4c5b29950fc5399019c042d145d2a76e.png",
    "https://cdn.faire.com/fastly/c8d01c3a9afa988dd923dd333259ef60ba73c46dcce9771dc1fd84b3637cdbfe.png",
    "https://cdn.faire.com/fastly/8ebb22b93ea56c12cbb77c3bf70ed892c02686e78ee0d8dead67897845e61878.png",
  ],
  priceDollars: 35.74,
  description:
    "The ice cream parlor meets the baseball diamond - put the cherry on top of your baseball drip with a waffle cone full of sugary goodness. \n\n\nOur premium ultra-light short sleeve baseball hoodies are made with our buttery-soft HyperMAX fabric, a perfect pullover for the practice field or the couch.\n\n * Base Color = Cream \n * 100% HyperMAX Performance Polyester \n * Six-way stretch \n * Short sleeve\n\n * Hooded\n\n * In-stock and ships within 24 hours. ",
  tags: [],
  msrpDollars: 54.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:13.414Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
